import { render, staticRenderFns } from "./AddToCompare.vue?vue&type=template&id=970186ca&scoped=true"
import script from "./AddToCompare.vue?vue&type=script&lang=js"
export * from "./AddToCompare.vue?vue&type=script&lang=js"
import style0 from "./AddToCompare.vue?vue&type=style&index=0&id=970186ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970186ca",
  null
  
)

export default component.exports